export default __webpack_public_path__ + "static/media/medina.12cfc2bb.png";